export default __webpack_public_path__ + "media/317649abbae214b9c35592fdad5e5999e548934ea8f02a4c64de4a6be3dfc510.svg";